import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { Context } from "../Context/GlobalState";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function Signup({ history }) {
  const { signup, authError } = useContext(Context);
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [fullName, setFullName] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSignup = (e) => {
    e.preventDefault();

    setIsLoading(true);
    signup(
      email,
      username,
      fullName,
      password,
      "default",
      () => history.push("/home"),
      () => setIsLoading(false)
    );
  };

  return (
    <div className="signup__container">
      <h1>XenCodes</h1>
      <div className="form__area">
        <div className="form">
          <form onSubmit={handleSignup}>
            <div className="form__field">
              <input
                type="email"
                id="Email"
                name="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <label htmlFor="Email">Email</label>
            </div>
            <div className="form__field">
              <input
                type="text"
                id="Username"
                name="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
              <label htmlFor="Username">Username</label>
            </div>
            <div className="form__field">
              <input
                type="text"
                id="FullName"
                name="FullName"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
              />
              <label htmlFor="FullName">Full Name</label>
            </div>
            <div className="form__field">
              <input
                type="password"
                id="password"
                name="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <label htmlFor="Password">Password</label>
            </div>
            <button className="primary-btn" disabled={isLoading}>
              {!isLoading ? (
                "Sign up"
              ) : (
                <CircularProgress size={20} color="inherit" />
              )}
            </button>
            <div className="auth__error">
              <small>{authError}</small>
            </div>
          </form>
        </div>
        <div className="signup__area">
          <p>
            Have an account <Link to="/">Log in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
